import React from 'react';
import { Loader2 } from 'lucide-react';

export default function SettingsLoadingState({ label = 'Caricamento impostazioni…', testId = 'settings-loading' }) {
  return (
    <div className="flex min-h-28 items-center justify-center rounded-xl border border-app-border bg-app-surface text-sm text-stone-500" data-testid={testId}>
      <Loader2 className="mr-2 h-5 w-5 animate-spin text-brand-green" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}